import { Stack, Typography, Grid } from "@mui/material";
import Image from "next/image";
import theme from "@/theme/theme";

import zkAndPqcIcon from "@/assets/images/servicesPage/zkIcon.webp";
import zkAndPqcAsset from "@/assets/images/servicesPage/zkAsset.webp";

const ZkAndPqc = () => {
    return (
        <Stack
            direction={{ xs: "column", lg: "row" }}
            alignItems="start"
            justifyContent="center"
            width={{ xs: "100%", lg: "80%" }}
            marginX="auto"
            paddingX={4}
            gap={6}
            position="relative"
            overflow="hidden"
        >
            <Stack width={{ xs: "100%", lg: "50%" }} gap={4}>
                <Stack gap={2}>
                    <Stack direction={"row"} alignItems={"center"} gap={1.5}>
                        <Image src={zkAndPqcIcon} alt="sc icon" height={30} width={30} style={{ height: "auto", width: "auto" }} />
                        <Typography variant="h3" component="h3" className="chno" fontWeight={400} textTransform="uppercase" marginBottom={0.5} fontSize={{ xs: "1.3rem !important", lg: "1.75rem !important" }}>
                            ZK & PQC
                        </Typography>
                    </Stack>
                    <Typography variant="h6" component="h6" fontWeight={400} sx={{ width: "90%", display: { xs: "none", lg: "block" } }}>
                    Cybersecurity Audits – We perform end-to-end security assessments of web platforms, APIs, and smart contracts to uncover vulnerabilities, reinforce digital defenses, and ensure data integrity across systems.
                    </Typography>
                </Stack>
                <Image src={zkAndPqcAsset} alt="sc asset" height={450} width={450} /> 
            </Stack>
            <Stack width={{ xs: "100%", lg: "50%" }} gap={4}>
                <Grid container spacing={3} sx={{
                    width: "100%",
                }}>
                    <Grid size={{ xs: 12, lg: 12 }}>
                        <Stack gap={1}>
                            <Typography variant="h6" component="h6" fontWeight={400}>
                                Zero Knowledge Proof 
                            </Typography>
                            <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                We build zk-based frameworks enabling verifiable, privacy-preserving
                                computation and authentication in decentralized and enterprise environments.
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, lg: 12 }}>
                        <Stack gap={1}>
                            <Typography variant="h6" component="h6" fontWeight={400}>
                                Cryptography Models
                            </Typography>
                            <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                We design and implement advanced encryption, key management, and 
                                digital signature schemes that secure distributed and hybrid architectures.
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, lg: 12 }}>
                        <Stack gap={1}>
                            <Typography variant="h6" component="h6" fontWeight={400}>
                                Post-Quantum Migration
                            </Typography>
                            <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                We future-proof infrastructures by developing migration frameworks
                                and cryptographic protocols resistant to quantum-level threats.
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Stack>
    );
};

export default ZkAndPqc;